<template>
  <div class="help-center">
    <div class="main">
      <card>
        <el-tabs v-model="activeName" class="help-center__tabs">
          <el-tab-pane
            v-for="domain in domains"
            :key="domain.language"
            :label="`Text ${domain.language.toUpperCase()}`"
            :name="`Text ${domain.language.toUpperCase()}`"
          >
            <base-input
              :label=" domain.language === 'en' ? `Question ${domain.language.toUpperCase()} (required field)` : `Question ${domain.language.toUpperCase()}`"
              placeholder="Question"
              v-model="question.question[domain.language]"
            ></base-input>
            <label>{{ domain.language === 'en' ? `Answer ${domain.language.toUpperCase()} (required field)` : `Answer ${domain.language.toUpperCase()}` }}</label>
            <ckeditor
              v-if="activeName === `Text ${domain.language.toUpperCase()}`"
              :config="{ allowedContent: true }"
              v-model="question.answer[domain.language]"
            ></ckeditor>
          </el-tab-pane>
        </el-tabs>
      </card>
      <div class="help-center__sides">
        <card title="Relations">
          <div v-for="field in selectFields" :key="field.label">
            <label>{{ field.label }}</label>
            <el-select
              v-model="$data[field.model]"
              :placeholder="$data[field.label]"
              no-data-text="No data"
              no-match-text="No match"
              filterable
              reserve-keyword
              value-key="id"
              clearable
            >
              <el-option
                v-for="item in field.options"
                :key="item.id"
                :label="item.name.en"
                :value="item.alias.en"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <label>Category (required field)</label>
            <el-select
              v-model="question.category"
              placeholder="Category"
              no-data-text="No data"
              no-match-text="No match"
              filterable
              reserve-keyword
              value-key="id"
              clearable
            >
              <el-option
                v-for="category in categoriesList"
                :key="category.id"
                :label="category.title.en"
                :value="category"
              >
              </el-option>
            </el-select>
          </div>
          <base-input
            label="Doctor alias"
            placeholder="Doctor alias"
            v-model="question.doctorAlias"
          ></base-input>
        </card>
        <div>
          <card title="Image">
            <div class="help-center__upload">
              <span class="help-center__upload-title">Question Image</span>
              <img class="help-center__img" v-if="img" :src="img" />
              <button
                class="help-center__upload-button"
                @click="$refs['fileMain'].click()"
              >
                <i>upload</i>
                <input
                  type="file"
                  ref="fileMain"
                  name="fileMain"
                  @change="handleFileUpload"
                  style="position: absolute;left: -5000px;"
                />
              </button>
            </div>
          </card>
          <card title="Others">
            <div class="checkbox-group">
              <div class="checkbox-group__label">
                Enabled on locale
              </div>
              <div class="checkbox-group__group">
                <el-checkbox-group v-model="enabledOnLocales" class="flex">
                  <el-checkbox
                    v-for="domain in domains"
                    :key="domain.language"
                    :label="domain.language"
                    :value="domain.language"
                  />
                </el-checkbox-group>
              </div>
            </div>
            <div class="checkbox-group">
              <div class="checkbox-group__label">
                Is active
              </div>
              <div class="checkbox-group__group">
                <el-switch
                  v-model="isActive"
                  active-color="#a3cc0e"
                  inactive-color="#EAECF0"
                />
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
    <div class="help-center__button-wrapper">
      <button class="btn btn-primary" @click.prevent="create">Create</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data: () => ({
    activeName: null,
    question: {
      question: {},
      answer: {},
      category: {},
      doctorAlias: ""
    },
    isActive: true,
    enabledOnLocales: [],
    currentIllness: [],
    currentDiagnostic: [],
    currentOperation: [],
    currentIllnessKind: [],
    currentCountry: [],
    img: null,
    fileMain: ""
  }),
  computed: {
    ...mapState("cmsApiCatalogs", [
      "illnesses",
      "diagnostics",
      "operations",
      "domains",
      "illness-kinds",
      "countries"
    ]),
    ...mapState("helpCenterCategories", ["categoriesList"]),
    illnessKinds() {
      return this["illness-kinds"];
    },
    relativeFields() {
      return [
        { key: "operation", value: this.currentOperation },
        { key: "illness", value: this.currentIllness },
        { key: "diagnostic", value: this.currentDiagnostic },
        { key: "illness_kind", value: this.currentIllnessKind },
        { key: "country", value: this.currentCountry }
      ].filter(item => item.value);
    },
    enabledOnLocaleResult() {
      return this.domains.reduce((acc, { language }) => {
        acc[language] = this.enabledOnLocales.includes(language);
        return acc;
      }, {});
    },
    selectFields() {
      return [
        { label: "Illness", model: "currentIllness", options: this.illnesses },
        {
          label: "Diagnostic",
          model: "currentDiagnostic",
          options: this.diagnostics
        },
        {
          label: "Operation",
          model: "currentOperation",
          options: this.operations
        },
        {
          label: "Illness Kind",
          model: "currentIllnessKind",
          options: this.illnessKinds
        },
        { label: "Country", model: "currentCountry", options: this.countries }
      ];
    }
  },
  created() {
    this.getDomainsEvent();
    this.getIllnesses({ perPage: 1500 });
    this.getOperations();
    this.getCountries({ perPage: 1500 });
    this.getDiagnostics({ perPage: 1500 });
    this.getIllnessKinds({ perPage: 1500 });
    this.getCategoriesList();
  },
  methods: {
    ...mapActions("helpCenter", ["createQuestion", "addImage"]),
    ...mapActions("helpCenterCategories", ["getCategoriesList"]),
    ...mapActions("helpCenterCategories", ["getCategoriesList"]),
    ...mapActions("cmsApiCatalogs", [
      "getIllnesses",
      "getOperations",
      "getCountries",
      "getDiagnostics",
      "getIllnessKinds",
      "getDomains"
    ]),
    async getDomainsEvent() {
      await this.getDomains();
      this.activeName = `Text ${this.domains[0].language.toUpperCase()}`;
    },
    async create() {
      if (!this.question.answer.en || !this.question.question.en){
        return this.$notify({ type: "warning", title: "EN question and answer should not be empty" });
      }
      if (!this.question.category.title){
        return this.$notify({ type: "warning", title: "Please choose category" });
      }
      this.$store.dispatch("setLoader", true);
      const data = {
        ...this.question,
        relations: this.relativeFields,
        enabled_on_locale: this.enabledOnLocaleResult,
        is_active: this.isActive
      };

      await this.createQuestion(data).then(response => {
        if (this.img) {
          this.addImage({ id: response.data.question.id, file: this.fileMain })
            .catch(error => {
              this.$notify({ type: "warning", title: "Error" });
            })
            .finally(() => {
              this.$store.dispatch("setLoader", false);
            });
        }
        this.$router.push("list");
        this.$notify({ type: "success", title: "Question has been created" });
        this.$store.dispatch("setLoader", false);
      });
    },
    handleFileUpload(event) {
      const file = event.target.files[0];

      if (
        file.type &&
        (file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "image/png")
      ) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          this.img = reader.result;
        });
        if (file) {
          reader.readAsDataURL(file);
        }
        this.fileMain = file;
        return null;
      }
      this.$notify({
        type: "warning",
        title: "Make sure your photos have .jpg, .jpeg, .png file types"
      });
      return;
    }
  }
};
</script>
